import Alpine from 'alpinejs';
import { GoogleAuth } from './google_auth';

Alpine.data('googleAuth', () => new GoogleAuth());
